angular.module('rjmNg.api').factory 'StructureCache', [
  '$q'
  'app'
  '$http'
  'serviceUrl'
  'Structure'
  'References'
  'Columns'
  'Reference'
  ($q, app, $http, serviceUrl, Structure, References, Columns, Reference) ->

    StructureCache = {}

    # Cache the structure and references objects so we only have to query the
    # server and parse the response once for each object.
    structure = null
    references = null

    # Get a list of tables from the schema service
    # Returns a promise
    getTables = (clientId=app.getClientId(), force=false) ->
      deferred = $q.defer()

      $http(
        method: "GET"
        url: serviceUrl("/clients/#{clientId}/tables")
        cache: not force
        withCredentials: true
      ).then(
        ({data}) ->
          deferred.resolve(data)
      ).catch(
        (error) ->
          deferred.reject(error)
      )

      return deferred.promise

    # Create a list of references from an object whose proporities are column ids
    # and whose values are column objects, each containing at minimum a
    # table_id. References are created for any column which has a non-zero
    # reference_column_id. We also use the tables in order to get their names
    # when we create the Reference, which is why we need the whole structure now
    getReferencesFromStructure = (structure) ->
      references = []
      columns = structure.columns

      for id, column of columns when column.reference_column_id isnt 0
        other_column = columns[column.reference_column_id]

        # If, for whatever reason,the referenced column doesn't exist, ignore
        # the reference.
        continue unless other_column?

        from =
          table: column.table_id
          column: column.id
        to =
          table: other_column.table_id
          column: other_column.id

        reference = new Reference(from, to, structure)
        references.push reference

      new References(references)

    # Returns a promise which resolves to an object containing the references.
    StructureCache.getReferences = (force=false) ->
      deferred = $q.defer()

      if references? and not force
        deferred.resolve(references)
      else if structure? and not force
        references = getReferencesFromStructure(structure)
        deferred.resolve(references)
      else
        @getStructure(force).then(
          (structure) ->
            references = getReferencesFromStructure(structure)
            deferred.resolve(references)
          , (error) ->
            deferred.reject(error)
        )

      return deferred.promise

    # Returns a promise which resolves to an object containing the structure.
    StructureCache.getStructure = (force=false) ->
      deferred = $q.defer()

      if structure? and not force
        deferred.resolve(structure)
      else
        $q.all([ getTables(app.getClientId(), force), Columns.query({}, true) ]).then(
          (response) ->
            [tables, columns] = response
            structure = new Structure(tables, columns)
            deferred.resolve(structure)
          , (error) ->
            deferred.reject(error)
        )

      return deferred.promise

    # Returns a promise which resolves to an object containing the structure and
    # references.
    StructureCache.getStructureAndReferences = (force=false) ->
      deferred = $q.defer()

      # References depends on structure, so if we get the structure, the
      # cached structure is valid.
      @getReferences(force).then(
        () ->
          result =
            structure: structure
            references: references
          deferred.resolve(result)
        , (error) ->
          deferred.reject(error)
      )

      return deferred.promise

    StructureCache
  ]
